// extracted by mini-css-extract-plugin
export default {"container":"I6Z64N4ZTSfczmlBBgMU","show":"acyd6ZIRg2O_4PXY3sFB","loadingWrapper":"l97tlZ7cxRsjeq_jHXQd","title":"tQPPvFvNk15aKbwMEvim","subtext":"OzWzXkAEnrT6DscQlEzu"};